import { ReactNode, useEffect, useState } from "react";
import { MatchStatus } from "../../../types/stats";
import { TeamContext } from "../../../types/common";
import { Loader } from "../../../components/Loader";
import { CalendarEvent } from "../../../components/CalendarCarousel/CalendarEvent";
import { getStaticUrl, getUrlByContext } from "../../../utils";
import { getCalendar } from "../../../api/transport/fixturesTransport";
import { MatchInfoShort } from "../../../types/fixtures";
import { ClockCircleOutlined } from "@ant-design/icons";

interface MatchListWidgetProps {
    tournamentId: number;
    tournamentUuid?: string;
    seasonId: number;
    teamId?: number;
    teamName?: TeamContext;
}

export const MatchListWidget: React.FC<MatchListWidgetProps> = ({ tournamentId, tournamentUuid, seasonId, teamId, teamName }) => {
    const [mathcList, setMatchList] = useState<MatchInfoShort[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getCalendar(tournamentUuid).then((data) => {
            setMatchList(data);
            setLoading(false);
            if (teamName !== TeamContext.ACADEMY) {
                setTimeout(() => {
                    const scroll = document.querySelector('#scrollTo');
                    scroll?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }, 500);
            }
        }).finally(() => {
            setLoading(false);
        });
    }, [seasonId, tournamentId, teamId, teamName]);

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <div className="flex flex-row flex-wrap mx-auto justify-center gap-2 p-2">
                {mathcList.map(m => {
                    const protocolUrl = getUrlByContext(`/matches/matchcenter/${m.id}/`, teamName);
                    const date = new Date(m.date);
                    let dateTime = 'Дата не определена';
                    if (!m.preliminaryDate && !isNaN(date.getTime())) {
                        if (!date.getHours() && !date.getMinutes()) {
                            dateTime = date.toLocaleDateString('ru-RU', {
                                day: 'numeric',
                                month: 'long'
                            });
                        } else {
                            dateTime = date.toLocaleDateString('ru-RU', {
                                day: 'numeric',
                                month: 'long',
                                hour: '2-digit',
                                minute: '2-digit',
                            });
                        }
                    }

                    let scoreNode: ReactNode = '';
                    if (m.status === MatchStatus.FINISHED) {
                        scoreNode = (
                            <div className="flex flex-col items-center gap-1">
                                <span className="text-5xl font-bold">{m.score}</span>
                            </div>
                        );
                    } else if (m.status === MatchStatus.IN_PROGRESS) {
                        scoreNode = <span className="text-5xl font-bold animate-pulse">LIVE</span>
                    } else if (m.status === MatchStatus.UPCOMING) {
                        //scoreText = '-';
                    } else if (m.status === MatchStatus.CANCELED) {
                        scoreNode = <span className="text-orange-400 text-3xl"><ClockCircleOutlined title="Ожидание результата" /></span>;
                    }

                    return (
                        <a className="sm:max-w-[320px] w-full active:scale-95 transition-all hover:no-underline" href={protocolUrl}>
                            <CalendarEvent
                                name={/*tounamentInfo?.name || */''}
                                url=""
                                date={dateTime}
                                team1={{
                                    name: m.homeTeam.name,
                                    logo: getStaticUrl(m.homeTeam.logo)
                                }}
                                team2={{
                                    name: m.guestTeam.name,
                                    logo: getStaticUrl(m.guestTeam.logo)
                                }}
                                score={scoreNode}
                                matchUrl={protocolUrl}
                                ticketUrl={m.links?.ticketUrl}
                                //parkingUrl={m.status === MatchStatus.UPCOMING ? m.parkingUrl : undefined}
                                classNames="!text-slate-950 !bg-white border border-solid border-slate-200"
                            />
                        </a>
                    )
                })}
            </div>
        </>
    );
}

